import { computed, ref } from 'vue'

import { isLocatableAddressText } from '~/lib/geo-providers/isLocatableAddressText'

/** Holds the text typed into an address widget's fallback input and whether the server can geocode it. */
export const useFallbackAddressText = () => {
  const text = ref('')
  const hasLocatableText = computed(() => isLocatableAddressText(text.value))

  const set = (value: string): void => {
    text.value = value
  }

  const reset = (): void => {
    text.value = ''
  }

  return { hasLocatableText, reset, set, text }
}
